import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import usePost from "../../hooks/api/usePost";
import InputField from "../../components/ui/form/InputField";
import Button from "../../components/ui/utils/Button";
import apiRequest from "../../utils/apiRequest";
import { setUserProfile } from "../../store/slice/globalStore";
import { useEffect } from "react";
import { HOME_ROUTE } from "../../routes/web/rootRoutes";

const Profile = () => {
  const userProfile = useSelector((state) => state.globalState.userProfile);
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.updateProfile);

  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: userProfile?.name || "",
      email: userProfile?.email || "",
      mobile: userProfile?.mobile || "",
      corporateCode: userProfile?.code,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email address").optional(),
      mobile: Yup.string()
        .matches(/^\d{10}$/, "Mobile number must be 10 digits")
        .required("Mobile number is required"),
    }),
    onSubmit: async (values) => {
      const response = await post({ data: { body: values } });
      console.log(response,123);
      
      dispatch(setUserProfile(response?.data?.user));
      setTimeout(() => {
        window.location.href = HOME_ROUTE
      }, 300)
    },
  });
  useEffect(() => {
    if (userProfile) {
      formik.setValues(userProfile);
    }
  }, [userProfile]);
  return (
    <div className="p-2 bg-white rounded-lg shadow-md">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-5">
          <h1 className="mb-6 text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-500 to-primary-200">
            Update Profile
          </h1>
          {error && <p className="text-red-500">{error}</p>}
          <div className="grid grid-cols-1 gap-4 mt-2 md:grid-cols-2">

            <InputField
              label="Name"
              id="name"
              type="text"
              placeholder="Enter name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.name && formik.errors.name}
              serverError={serverErrors?.name}
            />

            <InputField
              label="Corporate Code"
              id="corporateCode"
              type="text"
              placeholder="Enter corporate code"
              value={formik.values.corporateCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.corporateCode && formik.errors.corporateCode}
              serverError={serverErrors?.corporateCode}
            />

            {/* <InputField
              label="Email"
              id="email"
              type="email"
              placeholder="Enter email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && formik.errors.email}
              serverError={serverErrors?.email}
            /> */}

            <div className="col-span-full">
              <InputField
                label="Mobile"
                id="mobile"
                type="text"
                placeholder="Enter mobile number"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.mobile && formik.errors.mobile}
                serverError={serverErrors?.mobile}
              />
            </div>
          </div>
        </div>
        <div className="my-4 border-t border-gray-300"></div>
        <div className="flex items-center justify-end gap-4 p-4">
          <Button variant="primary" isLoading={loading} type="submit">
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Profile;
